import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, race, select, take } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, failedApiActionsMatcher } from "../../common";
import { industriesSelector } from '../selectors';
import industryCpdCategoryActionConfiguration from './cpdCategorys';
import { INDUSTRY_ENDPOINT } from './endpoints';
import industryRoleActionConfiguration from './roles';

const actions = createActions({
  INDUSTRIES: {
    GET: (userIndustry) => ({ userIndustry }),
    API: {
      GET: apiResourceActionCreator('industries')
    }
  }
})

export const apiAction = () => commonApiActions.get(INDUSTRY_ENDPOINT, actions.industries.api.get)

function getIndustriesResult() {
  return race({
    getIndustriesSuccess: take(actions.industries.api.get.success),
    getIndustriesFailed: take((action) => failedApiActionsMatcher(action, actions.industries.api.get))
  });
}

export function* fetchIndustries({ payload }) {
  yield put(apiAction());

  const { getIndustriesSuccess } = yield getIndustriesResult();

  if (getIndustriesSuccess && payload.userIndustry) {
    const industries = yield select(industriesSelector);
    const selectedIndustryName = payload.userIndustry;
    const selectedIndustry = fp.find((industry) => industry.identifier === selectedIndustryName)(industries)
    if (industries.length > 0) {
      yield put(industryRoleActionConfiguration.action.industries.getRoles(selectedIndustry.id));
      yield put(industryCpdCategoryActionConfiguration.action.industries.getCpdCategorys(selectedIndustry.id));
    }
  }
}

const configuration = {
  name: 'get',
  action: actions,
  sagas: fetchIndustries,
  reducers: {
    request: (state, action) => {
      return Object.assign({}, state, {
        isFetching: true
      });
    },
    success: (state, action) => {
      return Object.assign({}, state, {
        isFetching: false,
        industries: action.payload.industries
      });
    },
    failed: (state, action) => {
      return Object.assign({}, state, {
        isFetching: false,
        error: action.payload.error
      });
    },
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/industry/configurations/get.js